/**
 * Formats raw digits into a Brazilian phone display: +55 XX XXXXX-XXXX (mobile) or +55 XX XXXX-XXXX (landline).
 */
export function formatWhatsApp(digits: string): string {
  const clean = digits?.replace(/\D/g, '') || ''
  if (clean.length === 0) return ''

  // Expected: 55 + DDD (2) + number (8-9) = 12-13 digits
  const cc = clean.slice(0, 2)   // 55
  const ddd = clean.slice(2, 4)  // area code
  const number = clean.slice(4)

  if (!ddd) return `+${cc}`
  if (!number) return `+${cc} ${ddd}`

  if (number.length <= 4) return `+${cc} ${ddd} ${number}`
  if (number.length <= 8) return `+${cc} ${ddd} ${number.slice(0, 4)}-${number.slice(4)}`

  // 9-digit mobile
  return `+${cc} ${ddd} ${number.slice(0, 5)}-${number.slice(5, 9)}`
}

/**
 * Processes user input for the WhatsApp field: strips non-digits, enforces 55 prefix, caps at 13 digits.
 * Returns the formatted display string.
 */
export function parseWhatsAppInput(value: string): string {
  let digits = value.replace(/\D/g, '')

  // Enforce 55 prefix
  if (digits.length > 0 && !digits.startsWith('5')) {
    digits = '55' + digits
  } else if (digits.length > 1 && digits.startsWith('5') && !digits.startsWith('55')) {
    digits = '5' + digits
  }

  // Cap at 13 digits (55 + 2 DDD + 9 number)
  digits = digits.slice(0, 13)

  return formatWhatsApp(digits)
}
